/*
 * Ryan O'Dowd
 * 2025-05-24
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderRadius: globalScale * 4,
      width: globalScale * 260,
      padding: globalScale * 12,
      marginBottom: globalScale * 12,
      resizeMode: 'contain',
      backgroundColor: colors.white,
      color: colors.black,
    },
    disabledContainer: {
      opacity: 0.4,
    },
    authProviderIcon: {
      color: colors.black,
      fontSize: globalScale * 24,
      marginRight: globalScale * 18,
    },
    buttonText: {
      color: colors.black,
      fontSize: globalScale * 16,
      alignSelf: 'center',
    },
  };
};

export default getStyles;
